import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ImpactMapPageRoutingModule} from './impact-map-routing.module';
import {ImpactMapPage} from './impact-map.page';
import {HeaderModule} from "../../components/header/header.module";
import {TeamPageModule} from "../team/team.module";
import {TranslateDirective, TranslatePipe} from "@ngx-translate/core";
import {MapSidePanelComponent} from "../../components/z-impact-map/map-side-panel/map-side-panel.component";
import {MapLegendComponent} from "../../components/z-impact-map/map-legend/map-legend.component";
import {
    MapStatisticCirclesComponent
} from "../../components/z-impact-map/map-statistic-circles/map-statistic-circles.component";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImpactMapPageRoutingModule,
    HeaderModule,
    TeamPageModule,
    TranslatePipe,
    TranslateDirective,
    MapSidePanelComponent,
    MapLegendComponent,
    MapStatisticCirclesComponent,
    MapStatisticCirclesComponent
  ],
  exports: [ImpactMapPage],
  declarations: [ImpactMapPage]
})

export class ImpactMapPageModule {
}

